<div id="dialogHeader">
    <div class="fullWidth">
        <div id="title" class="left">
        <h3>
            {{ this.data.title }} | 
            <app-company-quoteid-header [quote]="this.quoteRequestState"></app-company-quoteid-header>
        </h3>
        </div>

        <div class="right">
        <mat-icon class="closeDialog" aria-hidden="false" [mat-dialog-close]="{ success: true }" aria-label="Close icon">close</mat-icon>
        </div>
    </div>
    
    <div id="padHeader" class="headerWidth">

      <div class="left">
          <mat-label class="custom-label">Quote Price History Date</mat-label>
          <mat-select  class="custom-margin-header-control" [(ngModel)]="selectedModifiedDate" required (selectionChange)="quotePriceModifiedDateChanged($event?.value);" placeholder="-- Please Select --"> 
            <mat-option value="" disabled>-- Please Select --</mat-option>
            <mat-option *ngFor="let quotePriceModifiedDate of quotePriceModifiedDateList" [value]="quotePriceModifiedDate">
              {{ quotePriceModifiedDate | date:'MM/dd/yyyy HH:mm' }}
            </mat-option>
          </mat-select>
      </div>

      <div class="left">
          <mat-label class="custom-label">New Contract Start Date:</mat-label><br>          
          <input  class="custom-margin-header-control" matInput [value]="selectedContractStartDate | date:'MM/dd/yyyy'" readonly>
      </div>

      <div class="left">
          <mat-label class="custom-label">Tax Inclusion:</mat-label>&nbsp;
          <mat-radio-group [(ngModel)]="isTaxIncluded" [disabled]="isReadOnly">
            <mat-radio-button [value]="true">Yes</mat-radio-button>
            <mat-radio-button [value]="false">No</mat-radio-button>
            &nbsp;
          </mat-radio-group>
      </div>
                
    </div>
</div>

<div class="horizontal-scroller vertical-scroller tableDiv">
    <table 
    
      style="width: 100%; text-align: right"
      mat-table
      [dataSource]="quoteHistoryDataSource"
      matSort
      multiTemplateDataRows
      class="noselect tenders-grid"
    >
      <caption>&nbsp;</caption>
      <ng-container matColumnDef="quoteTerm">
        <th class="historyHeaders" mat-header-cell *matHeaderCellDef>Term</th>
        <td mat-cell *matCellDef="let dataset">
          <span>{{ dataset.Term }}</span>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>
      
      <ng-container matColumnDef="quotePriceCurrent">
        <th class="historyHeaders" mat-header-cell *matHeaderCellDef> 
          Quote Price Current
        </th>
        <td mat-cell *matCellDef="let dataset">
          <span>{{ dataset.QuotePriceCurrent | number: '1.2-4' }}</span>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>
  
      <ng-container matColumnDef="quotePricePrevious">
        <th class="historyHeaders" mat-header-cell *matHeaderCellDef>
            Quote Price Previous
        </th>
        <td mat-cell *matCellDef="let dataset" class="previous-column">
          <span>{{ dataset.QuotePricePrevious | number: '1.2-4' }}</span>          
        </td>        
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <ng-container matColumnDef="brokerFeeCurrent">
        <th class="historyHeaders" mat-header-cell *matHeaderCellDef>
          Broker Fee Current
        </th>
        <td mat-cell *matCellDef="let dataset">
          <span>{{ dataset.BrokerFeeCurrent | number: '1.2-2' }}</span>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>
  
      <ng-container matColumnDef="brokerFeePrevious">
        <th class="historyHeaders" mat-header-cell *matHeaderCellDef>
          Broker Fee Previous
        </th>
        <td mat-cell *matCellDef="let dataset"  class="previous-column">
          <span>{{ dataset.BrokerFeePrevious | number: '1.2-2' }}</span>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>
  
      <ng-container matColumnDef="bdmFeeCurrent">
        <th class="historyHeaders" mat-header-cell *matHeaderCellDef>
          BDM Fee Current
        </th>
        <td mat-cell *matCellDef="let dataset">
          <span>{{ dataset.BdmFeeCurrent | number: '1.2-2' }}</span>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>        
      </ng-container>

      <ng-container matColumnDef="bdmFeePrevious">
        <th class="historyHeaders" mat-header-cell *matHeaderCellDef>
            BDM Fee Previous
        </th>
        <td mat-cell *matCellDef="let dataset"  class="previous-column">
          <span>{{ dataset.BdmFeePrevious | number: '1.2-2' }}</span>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <ng-container matColumnDef="marginCurrent" *ngIf="user.isSupplierManager">
        <th class="historyHeaders" mat-header-cell *matHeaderCellDef>
          Margin Current
        </th>
        <td mat-cell *matCellDef="let dataset">
          <span>{{ dataset.MarginFeeCurrent | number: '1.2-2' }}</span>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <ng-container matColumnDef="marginPrevious" *ngIf="user.isSupplierManager">
        <th class="historyHeaders" mat-header-cell *matHeaderCellDef>
          Margin Previous
        </th>
        <td mat-cell *matCellDef="let dataset" class="previous-column">
          <span>{{ dataset.MarginPrevious | number: '1.2-2' }}</span>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>
  
      <tr mat-header-row *matHeaderRowDef="quoteHistoryColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let element; columns: this.quoteHistoryColumns"></tr>
    </table>
  </div>
  
  <div class="fullWidthSolo">
    <div class="rightSolo">
      <button id="closeBtn" mat-flat-button color="accent" type="button" mat-dialog-close>Close</button>
    </div>
  </div>
